import axios from "axios";
import {FORBIDDEN_URL, LOGIN_URL} from "./common";


export const getVendorContacts = async () => {
    try {
        const response = await axios.get(`/vendor/contacts/index`);
        if (response.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        } else {
            return response.data;
        }
    } catch (error) {
        if (error.response.status === 403) {
            window.location.href = FORBIDDEN_URL;
        }
        return null;
    }
};

export const getVendorContactsForPrimary = async (vendorId) => {
    try {
        const response = await axios.get(`/vendor/${vendorId}/accounts/confirmed`);
        if (response.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        } else {
            return response.data;
        }
    } catch (error) {
        if (error.response.status === 403) {
            window.location.href = FORBIDDEN_URL;
        }
        return null;
    }
};

export const checkAccountEmail = async (email) => {
    try {
        const response = await axios.get(`/account/email/available?email=${email}`);
        if (response.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        } else {
            return response.data;
        }
    } catch (error) {
        if (error.response.status === 403) {
            window.location.href = FORBIDDEN_URL;
        }
        return null;
    }
};

export const setVendorPrimaryAccount = async (vendor_id, account_id) => {
    try {
        const response = await axios.post(`/vendor/contacts/set/primary`, {
            vendor_id: vendor_id,
            account_id: account_id
        });
        if (response.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        }
        return response.data;
    } catch (error) {
        console.error('Error resend update requests :', error);
        return null;
    }
};

export const vendorAddNewContact = async (first_name, last_name, email, role, type, contact_id = null) => {
    try {
        const response = await axios.post(`/vendor/contacts/create/account`, {
            first_name: first_name,
            last_name: last_name,
            email: email,
            role_id: parseInt(role),
            type_id: parseInt(type),
            contact_id: contact_id
        });
        if (response?.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        }

        return response?.data;
    } catch (error) {
        return error;
    }
};


export const vendorAddContact = async (vendor_id, account_id, type) => {
    try {
        const response = await axios.post(`/vendor/contacts/add`, {
            account_id: parseInt(account_id),
            vendor_id: parseInt(vendor_id),
            type_id: parseInt(type),
        });
        if (response.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        }
        return response.data;
    } catch (error) {
        console.error('Error resend update requests :', error);
        return null;
    }
};

export const vendorRemoveContact = async (id) => {
    try {
        const response = await axios.patch(`/vendor/contacts/remove`, {
            id: parseInt(id),
        });
        if (response.status === 401) {
            // window.location.href = LOGIN_URL;
            return null;
        }
        return response.data;
    } catch (error) {
        console.error('Error resend update requests :', error);
        return null;
    }
};

export const vendorUpdateContact = async (prevId, account_id) => {
    try {
        const response = await axios.patch(`/vendor/contacts/update`, {
            id: parseInt(prevId),
            account_id: parseInt(account_id)
        });
        if (response.status === 401) {
            // window.location.href = LOGIN_URL;
            return null;
        }
        return response.data;
    } catch (error) {
        console.error('Error resend update requests :', error);
        return null;
    }
};